import { useNavigate } from "react-router-dom";
import { useLogout } from "../../../../hooks/auth/useLogout";
import { Divider, Dropdown } from "@mui/joy";
import { Menu, MenuButton, MenuItem } from "@mui/joy";
import { DotsThreeCircleIcon, Eye, Flag, Prohibit, SignOut } from "@phosphor-icons/react";
import { useState } from "react";
import ModalConfirmDelete from "../../ModalConfirmDelete/ModalConfirmDelete";
import ModalComplain from "../../ModalComplain/ModalComplain";

export function ModalMore({ setShareOpen, side = false, id = 0, itsme = true, blocked = false, blockLoading = false, toggleBlock = () => { } }) {
    const navigate = useNavigate();
    const handleLogout = useLogout();

    const [openModalExit, setOpenModalExit] = useState(false);
    const [openComplain, setOpenComplain] = useState(false);

    const handlerClickExit = () => setOpenModalExit(true);

    return (
        <Dropdown>
            <MenuButton
                variant="soft"
                color="primary"
                sx={(theme) => ({
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '2px',
                    px: 2,
                    py: 1,
                    width: '56px',
                    height: '56px',
                    borderRadius: "999px",
                    color: theme.palette.mode === 'dark'
                        ? theme.palette.primary[100]
                        : null,
                    fontSize: '12px',
                    '& svg': {
                        width: '24px',
                        height: '24px',
                    }
                })}
            >
                <DotsThreeCircleIcon size={24} />
            </MenuButton>
            <Menu variant="plain" sx={{ borderRadius: '12px' }}>
                {side && (
                    // Свой профиль «со стороны» показывает те же пункты, но
                    // выключенными: вид со стороны на то и вид со стороны, чтобы
                    // меню выглядело так же, как у гостя, а не короче на два пункта.
                    <>
                        <MenuItem
                            color="danger"
                            sx={{ py: 1 }}
                            disabled={itsme || blockLoading}
                            onClick={toggleBlock}
                        >
                            <Prohibit size={20} style={{ marginRight: 4 }} />
                            {blocked ? 'Разблокировать' : 'Заблокировать'}
                        </MenuItem>
                        <MenuItem
                            color="danger"
                            sx={{ py: 1 }}
                            disabled={itsme}
                            onClick={() => setOpenComplain(true)}
                        >
                            <Flag size={20} style={{ marginRight: 4 }} />
                            Пожаловаться
                        </MenuItem>
                    </>
                )}

                {!side && (
                    <>
                        <MenuItem onClick={() => navigate(`/show/id/${id}`)} sx={{ py: 1 }}>
                            <Eye size={20} style={{ marginRight: 4 }} />
                            Вид со стороны
                        </MenuItem>
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem color="danger" onClick={handlerClickExit} sx={{ py: 1 }}>
                            <SignOut size={20} style={{ marginRight: 4 }} />
                            Выйти
                        </MenuItem>
                    </>
                )}
            </Menu>
            <ModalConfirmDelete
                open={openModalExit}
                setOpen={setOpenModalExit}
                onDelete={handleLogout}
                title="Подтвердите выход"
                desc="Вы действительно хотите выйти из аккаунта?"
                buttonActiveText="Выйти"
            />
            <ModalComplain
                open={openComplain}
                setOpen={setOpenComplain}
                complainFor={2}
                contentId={id}
            />
        </Dropdown>
    )
}
